import React, { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Row, Col, Container } from "react-bootstrap";
import { object, string, date } from 'yup';
import { CircularProgress, Button } from "@mui/material";
import moment from 'moment';
import QueryString from 'query-string';
import { useLocation, useNavigate } from 'react-router-dom';
import TextInput from '../Helpers/Inputs/TextInput';
import InputMaskDate from '../Helpers/Formatters/InputMaskDate';
import { SESSION_STORAGE_ESIGN_AUTH_KEY, getSessionStorageItem, setSessionStorageItem } from '../../sessionStorage';

import './Status.scss';

export default function Status() {

  const location = useLocation();
  const navigate = useNavigate();
  const queryString = QueryString.parse(location.search);

  const [loading, setLoading] = useState(false);
  const [birthdate, setBirthdate] = useState("");
  const [passcode, setPasscode] = useState("");
  const [errorMessage, setErrorMessage] = useState(false)

  const formMethods = useForm({
    resolver: yupResolver(object().shape({
      birthdate: date().typeError('Invalid date.')
        .max(moment(new Date()).subtract(1, 'days'), 'Birthdate must be in past.')
        .required('Birthdate is required.'),
      passcode: string().required(),
    })),
    mode: 'all',
    reValidateMode: 'all',
    defaultValues: { birthdate: '', passcode: '' },
  });

  const { handleSubmit } = formMethods;

  const onSubmit = () => {
    setLoading(true);
    setErrorMessage(false)
    setSessionStorageItem(SESSION_STORAGE_ESIGN_AUTH_KEY, { passcode: passcode, birthdate: birthdate, applicationID: queryString.id, clientUserID: queryString.rid })
    fetch(`${window.__ENV__.REACT_APP_COVR_SERVICES_URL}/api/AppStatus/GetAppStatus?passcode=${passcode}&birthdate=${birthdate}&applicationID=${queryString.id}`)
      .then(res => res.json())
      .then(json => {
        if (json.message === "Unable to retrieve status.") {
          setErrorMessage(true)
          setLoading(false)
        } else {
          setSessionStorageItem(SESSION_STORAGE_ESIGN_AUTH_KEY, { ...getSessionStorageItem(SESSION_STORAGE_ESIGN_AUTH_KEY), 'appStatusResponse': json });
          if (json.DateSigned == null) {
            navigate('/quote/whole-life/securian-secure-promise/sign');
          }
          else {
            if (json.StatusUrl) {
              navigate(json.StatusUrl);
            }
            else {
              navigate('/quote/whole-life/securian-secure-promise/status');
            }
          }
        }
      })
  }

  return (
    <Container className="appStatus mt-3 mb-3">

      <Row className="justify-content-center">
        {errorMessage ?
          <p class="alert alert-danger" role="alert"><b>Authentication Failed</b> <span>The information provided is incorrect</span></p>
          : ''}
      </Row>
      <Row className="justify-content-center">

        <Col lg={5}>
          <h1>Signer Authentication</h1>
          <p>
            Please enter your information below to access your electronic application. This information is used to verify your identity prior to accessing your application for e-signature or status.
          </p>

          <FormProvider {...formMethods}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className='mb-3'>
                <TextInput
                  name="birthdate"
                  id="birthdate"
                  label="Date of Birth"
                  value={birthdate}
                  onChange={(e) => setBirthdate(e.target.value)}
                  InputProps={{
                    inputComponent: InputMaskDate,
                  }}
                />
              </div>

              <div className='mb-3'>
                <TextInput
                  name="passcode"
                  id="passcode"
                  label="Last 4 of SSN"
                  value={passcode}
                  maxLength="4"
                  type="password"
                  onChange={(e) => setPasscode(e.target.value)}
                />
              </div>

              <div className='mb-3'>
                <Button type="submit" variant="contained" color="primary" fullWidth disabled={loading}>Continue</Button>
              </div>
            </form>
          </FormProvider>
        </Col>

      </Row>


      {loading &&
        <Row className="justify-content-center mt-3 mb-3">
          <Col xs={1}>
            <CircularProgress />
          </Col>
        </Row>
      }

      {/* {statusResponse && statusResponse.DateSigned &&
        <ApplicationStatus
          insuredName={statusResponse.InsuredName}
          coverageAmount={statusResponse.Coverage}
          productName="Secure Promise Whole Life"
          premium={statusResponse.Premium}
          email={statusResponse.EmailAddress}
        />
      } */}

    </Container>
  )
}
